// removed by extract-text-webpack-plugin
module.exports = {"common-radio":"common-radio"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/Radio/index.less
// module id = 709
// module chunks = 418